import "./main_view.css";
import { Canvas } from "@react-three/fiber";
// import { Scene } from './Scene'
import { Invessoft } from "./Invessoft";
import { useState } from "react";

function MainView() {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch('./docs', {
        method: 'POST',
        body: JSON.stringify({
            username: user,
            password
        })
    })
    if(res.status === 200) {
      setError(false);
      window.location.replace('../../docs');
    } else if(res.status === 401) {      
      setError(true);
      console.log('Usuario o contraseña incorrectos')
      return;
    }
    console.log(res)    
  };

  return (
    <>
      <div className="canvas-container">
        <Canvas shadows>
          <Invessoft />
        </Canvas>
      </div>

      <div className="diagonal-container"></div>

      <div className="login-container">
        <div className="login-box">
          <form id="loginForm" onSubmit={handleSubmit}>
            <div className="round-icon">
              <img src="./LogoIconRed.png" alt="Icon" />
            </div>
            <h1 className="title">Invessoft API</h1>
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              name="username"
              required
              value={user}
              onChange={(e) => setUser(e.target.value)}
            />
            <br />
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />            
            <div>
              {error && <p className="error" style={{color:'red', textAlign:'center'}}>Usuario o contraseña incorrectos</p>}
            </div>
            <br />
            <button type="submit">Log In</button>
            <br />
            <a href="https://invessoft.app">Ir al sitio oficial</a>
          </form>
        </div>
      </div>
    </>
  );
}

export default MainView;
